import React, { useEffect, useState } from 'react';
import { Button, Modal, Space, Spin, Table, Tag } from 'antd';
import { useQuery } from '@apollo/react-hooks';
import moment from 'moment';
import COMPLIANCE_AUDIENCES from '../../../core/GraphQl/Queries/COMPLIANCE_AUDIENCES';

const classificationTagConfig = {
  COMPLIANCE_MEDICAL: { color: 'green', label: 'Medical' },
  COMPLIANCE_RECREATIONAL: { color: 'blue', label: 'Recreational' },
  COMPLIANCE_BOTH: { color: 'purple', label: 'Both' },
};

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    ellipsis: true,
    width: 200,
  },
  {
    title: 'Classification',
    dataIndex: 'type',
    key: 'type',
    width: 150,
    render: (type) => {
      const config = classificationTagConfig[type] || { color: 'default', label: type };
      return <Tag color={config.color}>{config.label}</Tag>;
    },
  },
  {
    title: 'Locations',
    dataIndex: 'geoTargets',
    key: 'geoTargets',
    render: (geoTargets) =>
      geoTargets
        ? geoTargets.map((t) => (
            <Tag color="blue" key={t.id}>
              {t.name}
            </Tag>
          ))
        : 'N/A',
  },
  {
    title: 'Created',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: (date) => moment(date).format('MM/DD/YYYY hh:mma'),
  },
];

const CampaignRequestorComplianceAudiencesDialog = ({
  visible,
  setVisible,
  orgId,
  onAddSelections,
  selectedAudiences,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const { data, loading } = useQuery(COMPLIANCE_AUDIENCES, {
    variables: {
      where: {
        AND: [
          { type_in: ['COMPLIANCE_MEDICAL', 'COMPLIANCE_RECREATIONAL', 'COMPLIANCE_BOTH'] },
          { orgs_some: { id: orgId } },
        ],
      },
    },
    skip: !orgId,
  });

  const audiences =
    data &&
    data.audiencesConnection &&
    data.audiencesConnection.edges
      ? data.audiencesConnection.edges.map((edge) => edge.node)
      : [];

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const handleAddSelections = () => {
    if (selectedRowKeys.length === 0) {
      onAddSelections([]);
      setVisible(false);
      return;
    }
    const selected = audiences.filter((a) => selectedRowKeys.includes(a.id));
    onAddSelections(selected);
    setVisible(false);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  useEffect(() => {
    if (selectedAudiences && selectedAudiences.length > 0 && audiences.length > 0) {
      const keys = [];
      selectedAudiences.forEach((group) => {
        const match = audiences.find((a) => a.id === group.id);
        if (match) {
          keys.push(match.id);
        }
      });
      setSelectedRowKeys(keys);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [audiences.length]);

  return (
    <Modal
      title={
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingRight: 20,
          }}
        >
          <span>COMPLIANCE AUDIENCES</span>
          <div>
            <Button type="default" onClick={handleAddSelections}>
              Add Selection(s)
            </Button>
          </div>
        </div>
      }
      visible={visible}
      onCancel={() => handleAddSelections()}
      footer={null}
      width={1200}
    >
      {loading ? (
        <Space direction="vertical" style={{ width: '100%' }} align="center">
          <Spin />
        </Space>
      ) : (
        <Table
          rowKey={(record) => record.id}
          rowSelection={rowSelection}
          columns={columns}
          dataSource={audiences}
        />
      )}
    </Modal>
  );
};

export default CampaignRequestorComplianceAudiencesDialog;
